// Host-level HTTP convenience functions. These delegate to the active BFF
// adapter — the host never knows the concrete transport (REST, GraphQL, etc.)
// or how auth tokens are injected (resolved by AdapterRegistry at boot).

import { getBffAdapter, type BffRequestOptions } from '../../adapters';
import type { SseSubscription } from './fetchSse';

export type { BffRequestOptions as RequestOptions };
export { BffError as HttpError } from '../../adapters';

export function bffRequest<T = unknown>(
  path: string,
  options?: BffRequestOptions
): Promise<T> {
  return getBffAdapter().request<T>(path, options);
}

export function bffEventStream(path: string): SseSubscription {
  return getBffAdapter().openEventStream(path);
}

export function bffQuery<T = unknown>(
  document: string,
  variables?: Record<string, unknown>
): Promise<T> {
  const adapter = getBffAdapter();
  if (!adapter.query) {
    throw new Error(
      `Active BFF adapter "${adapter.name}" does not support GraphQL queries`
    );
  }
  return adapter.query<T>(document, variables);
}
